module.exports = __webpack_public_path__ + "static/me_tech-0c115ebf10798d4db1c5abdf2485c7ab.png";